







import { defineComponent, PropType } from "@vue/composition-api"

export default defineComponent({
  name: "RechargeBtnCustom",
  props: {
    showPopupBox: {
      type: Function as PropType<() => void>,
      required: true
    }
  }
})
